// Use relative URLs when frontend and backend are in the same container
export const API_BASE_URL = '';